export const setCookie = (name, value, props) => {
	props = props || {}

	var exp = props.expires

	if (typeof exp == "number" && exp) {

		var d = new Date()

		d.setTime(d.getTime() + exp * 1000)

		exp = props.expires = d

	}

	if (exp && exp.toUTCString) { props.expires = exp.toUTCString() }

	value = encodeURIComponent(value)

	var updatedCookie = name + "=" + value

	for (var propName in props) {

		updatedCookie += "; " + propName

		var propValue = props[propName]

		if (propValue !== true) { updatedCookie += "=" + propValue }
	}

	document.cookie = updatedCookie
}

export const getCookie = (name) => {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));

	return matches ? decodeURIComponent(matches[1]) : undefined;
}

export const deleteCookie = (name) => {
	setCookie(name, null, { expires: -1 })
}

// First parameter it's array, second string type
export const sortByQuery = (array, query) => {

	const sortedArray = array.filter(item => {

		if (item.channel || item.artist) {

			const channel = item.channel ? item.channel.toLowerCase() : '';
			const artist = item.artist.toLowerCase();

			if (channel.includes(query)) {
				return channel;
			}

			if (artist.includes(query)) {
				return artist;
			}

		}

	});

	return sortedArray;
};

export const convertToBase64 = blobObj => {
	return new Promise(resolve => {
		let reader = new FileReader();

		reader.readAsDataURL(blobObj);
		reader.onload = (e) => {
			resolve(e.target.result)
		};
	})
}